/*
 * @Date: 2022-07-05 20:02:37
 * @LastEditors: chuhongguang
 * @desc: 信息披露
 */
import DefaultLayout from '@/layout/index'

const baseLangKey = 'layout.headerBar';

export default   {
  path: '/disclosure',
  redirect: '/disclosure/circulars',
  component: DefaultLayout,
  name: 'disclosure',
  children: (pre => [
    {
      path: 'circulars',
      name: `${pre}circulars`,
      meta: {
        title: '公告与通函',
        langKey: baseLangKey + '.circulars'
      },
      component: () => import('@/views/disclosure/circulars/index.vue')
    },
    {
      path: 'stock-price',
      name: `${pre}stockPrice`,
      meta: {
        title: '股价信息',
        langKey: baseLangKey + '.stockPrice'
      },
      component: () => import('@/views/disclosure/stock-price/index.vue')
    },
  ])('disclosure-')
}